import React, { useContext, useState } from 'react';
import KhAlert from '../../Components/Alert/KhAlert';
import UserHeader from '../../Components/HeaderAndSidebar/UserHeader';
import './DatabaseBackup.css'
import axios from 'axios';
import { ApiURL } from '../../App';
import { UserInfokh } from '../../Contexts/UserContext';
import DeleteConfirmation from '../../Components/Delete Confirmation component/DeleteConfirmation';

const DatabaseBackup = () => {

    const userInfo_Now =useContext(UserInfokh);
     const [loading,setloadnig]=useState(false);
     const [alert_,SetAlert]=useState({Activate:false,msg:''});
     const [showConfirmation, setShowConfirmation] = useState({'active':false,'id':0});

      const handle_GetBackup_Submit = async (e) => {
          
            try {
              
              setloadnig(true); // Start loading
            const res = await axios.get(ApiURL+'DatabaseBackup/ExportDatabaseToJsonAsync', {
              headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
                'Authorization': `bearer ${userInfo_Now.auth.token}`
              },
              responseType: 'blob', 
            });
            // Get filename from Content-Disposition header
            let filename = 'backup.json'; // fallback name
            const disposition = res.headers.get
                                    ? res.headers.get('content-disposition')
                                    : res.headers['content-disposition'];
            if (disposition && disposition.includes('filename=')) {
                filename = disposition
                    .split('filename=')[1]
                    .replace(/['"]/g, '') // remove quotes
                    .trim().split('filename*=')[0]
                    .replace(';', '') // remove quotes
                    .trim();
                    
            }

              // Create a download link for the blob
            const blob = new Blob([res.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Name of the file (you can set dynamically)
              link.download = filename;

            // Append, click, and remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up the object URL
            window.URL.revokeObjectURL(url);
              setloadnig(false);
          } catch (error) {      
            SetAlert({Activate:true,msg:error+'تأكد من الاتصال بالانترنت'});
          setloadnig(false);
          }
          finally {
              setloadnig(false); // End loading
          }
          };
      const handle_StartNewSeason_Submit = async (e) => {
          
            try {
              setloadnig(true); // Start loading
            const res = await axios.get(ApiURL+'DatabaseBackup/StartNewSeason', {
              headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
                'Authorization': `bearer ${userInfo_Now.auth.token}`
              },
              responseType: 'blob', 
            });
            // Get filename from Content-Disposition header
            let filename = 'backup.json'; // fallback name
            const disposition = res.headers.get
                                    ? res.headers.get('content-disposition')
                                    : res.headers['content-disposition'];
            if (disposition && disposition.includes('filename=')) {
                filename = disposition
                    .split('filename=')[1]
                    .replace(/['"]/g, '') // remove quotes
                    .trim().split('filename*=')[0]
                    .replace(';', '') // remove quotes
                    .trim();
                    
            }

              // Create a download link for the blob
            const blob = new Blob([res.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Name of the file (you can set dynamically)
              link.download = filename;

            // Append, click, and remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up the object URL
            window.URL.revokeObjectURL(url);
            setloadnig(false);
            SetAlert({Activate:true,msg:'لقد بدأت موسم جديد، قم بإعادة تشغيل التطبيق لتحديث البيانات'});   
            
          } catch (error) {      
            SetAlert({Activate:true,msg:error+'تأكد من الاتصال بالانترنت'});
          setloadnig(false);
          }
          finally {
              setloadnig(false); // End loading
          }
          };

      const chooseAndUploadFile = async (e) => {

      const fileInput = document.getElementById('fileInput');

      // Trigger file dialog
      fileInput.click();

      // When a file is chosen
      fileInput.onchange = async function () {
      if (!fileInput.files.length) return;

      const file = fileInput.files[0];

      // Optional: double-check file extension in case user bypasses accept filter
      if (!file.name.toLowerCase().endsWith('.enc')) {
        SetAlert({Activate:true,msg:'فقط enc يمكن اختيار الملفات من نوع '});
        fileInput.value = ''; 
        return;
      }
      setloadnig(true);
      // Prepare form data
      const formData = new FormData();
      formData.append('file', file); // 'file' should match your API parameter name

      try {
        const res = await axios.post(
          ApiURL + 'DatabaseBackup/RestoreDatabaseFromJsonAsync',
          formData,
          {
            headers: {
              'Authorization': `Bearer ${userInfo_Now.auth.token}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        fileInput.value = ''; 
        setloadnig(false);
      SetAlert({Activate:true,msg:'تم استعادة النسخة المحددة'});

      } catch (err) {
          fileInput.value = ''; 
        setloadnig(false);
        SetAlert({Activate:true,msg:err+'تأكد من الاتصال بالانترنت'});
      }
      };
      }

const handleClose = () => {
      setShowConfirmation({'active':false,'id':0});
    };
function handleConfirm() {
      // Perform the delete action here
      chooseAndUploadFile();
      setShowConfirmation({'active':false,'id':0});
    }
    return (
     <div>
             <KhAlert Kh_Active={alert_.Activate} msg={alert_.msg} func_setactive={SetAlert} />
                        <UserHeader title='النسخ الاحتياطي' SearchActivator={false} Active={16}/>
                        <div className='background-kh' ></div>
                        <div id='scrollableDiv' style={{ height:'100vh',overflow: 'auto',padding: '5px'}}>
                           <div className='DbBackup-kh' onClick={()=>handle_GetBackup_Submit()}>
                                <img src='img/backUp2.png' />
                                <label > أخذ نسخة احتياطية</label>
                           </div>
                           <div className='DbBackup-kh' onClick={()=>setShowConfirmation({'active':true,'id':0})}>
                            <input type="file" id="fileInput" style={{display:'none'}} />
                                <img src='img/restore.png' />
                                <label > استعادة نسخة سابقة</label>
                           </div>
                           <div className='DbBackup-kh' onClick={()=>handle_StartNewSeason_Submit()}>
                                <img src='img/startnew.png' />
                                <label > بدء موسم جديد </label>
                           </div>
                        <br/> 
                        <br/> 
                        <br/> 
                        
                        </div>
                       {loading && <div className='loader-parent'> <div className="loader"></div></div>} 
                   <DeleteConfirmation
                  show={showConfirmation}
                  handleClose={handleClose}
                  handleConfirm={handleConfirm}
                  title='تأكيد الرجوع إلى نسخة سابقة'
                  msg='سيتم حذف جميع البيانات الحالية والرجوع إلى نسخة سابقة، تأكد من أخذ نسخة احتياطية للبيانات الحالية قبل الاستعادة'
                  msgConfirmbtn='متابعة'
                />     
        </div>
       
    );
}

export default DatabaseBackup;
